// import moment from 'moment';
// import React, { useEffect, useRef, useState } from 'react';
import React, { useRef } from 'react';

import CountDownCard from './CountDownCard';

const CountDownTimer = () => {
	//card ref
	const SecondsCardRef = useRef(null);
	const MinutesCardRef = useRef(null);
	const HoursCardRef = useRef(null);
	const DaysCardRef = useRef(null);

	//day & time calculation
	// let currentDate = moment().format().slice(0, 19);
	// let timeLeft = 16 - currentDate.slice(8, 10);
	// let hoursLeft = 9 - currentDate.slice(11, 13);
	// let minutesLeft = 60 - currentDate.slice(14, 16);
	// let secondsLeft = 60 - currentDate.slice(17, 19);

	//state
	// const [days, setDays] = useState(0);
	// const [hours, setHours] = useState(0);
	// const [minutes, setMinutes] = useState(0);
	// const [seconds, setSeconds] = useState(0);

	// useEffect(() => {
	// 	seconds === 0 && setSeconds(59);
	// 	minutes === 0 && setMinutes(59);
	// 	if (seconds > 0) {
	// 		setTimeout(() => {
	// 		setSeconds(seconds - 1);
	// 		SecondsCardRef.current.classList.toggle('rotate');
	// 		}, 1000);
	// 	}
	// 	if (seconds === 0 && minutes > 0) {
	// 		setMinutes(minutes - 1);
	// 		MinutesCardRef.current.classList.toggle('rotate');
	// 	}
	// }, [seconds, minutes]);

	// useEffect(() => {
	// 	hours === 0 && setHours(23);
	// 	if (minutes === 0 && hours > 0) {
	// 		setHours(hours - 1);
	// 		HoursCardRef.current.classList.toggle('rotate');
	// 	}
	// }, [minutes, hours]);

	// useEffect(() => {
	// 	days === 14 && setDays(13);
	// 	hours === 0 &&
	// 		setDays(days - 1) &&
	// 		DaysCardRef.current.classList.toggle('rotate');
	// }, [hours, days]);

	return (
		<div className="countdown__container text-center">
			<CountDownCard
				label="days"
				// number={days}
				number={0}
				cardRef={DaysCardRef}
			/>
			<CountDownCard
				label="hours"
				// number={hours}
				number={0}
				cardRef={HoursCardRef}
			/>
			<CountDownCard
				label="minutes"
				// number={minutes}
				number={0}
				cardRef={MinutesCardRef}
			/>
			<CountDownCard
				label="seconds"
				// number={seconds}
				number={0}
				cardRef={SecondsCardRef}
			/>
		</div>
	);
};

export default CountDownTimer;
